import { Component, OnInit } from '@angular/core';
import {  Router, ActivatedRoute } from '@angular/router';
import { AuthenticationService } from 'src/app/user/_services/authentication.service';

@Component({
  selector: 'app-verify',
  templateUrl: './verify.component.html',
  styleUrls: ['./verify.component.scss']
})
export class VerifyComponent implements OnInit {

  constructor(private router:Router, private route: ActivatedRoute, private authenticationService: AuthenticationService) { }

  ngOnInit() {
    if(!this.route.queryParams['uid'] && !this.route.queryParams['sid'] && !this.route.queryParams['token']){
      const currentUser = this.authenticationService.currentUser;
        if (currentUser && currentUser.permissions) {
          setTimeout(() => {
            this.router.navigateByUrl('/dashboard');
          }, 0);  
        }else{
          if(!currentUser){
            sessionStorage.removeItem("psiData");
            this.router.navigateByUrl('/login');
          }
        }
    }
  }

}
